import client from "../client";

export const createAgent = async ({ name, services, settings }) =>
  client.post("/admin/agent", {
    name,
    services,
    settings,
  });

export const getAgent = async ({ agentId }) =>
  client.get(`/admin/agent/${agentId}`);

export const updateAgent = async ({ agentId, name, services, settings }) =>
  client.put(`/admin/agent/${agentId}`, {
    name,
    services,
    settings,
  });

export const deleteAgent = async ({ agentId }) =>
  client.delete(`/admin/agent/${agentId}`);

export const getAgents = async ({ limit, offset }) =>
  client.get(`/admin/agent`, { params: { limit, offset } });

export const getAgentMainFields = async () => client.get("/admin/agent/fields");

export const setAgentToPhonesNumbers = async ({ agentId, phoneNumbers }) =>
  client.put(`/admin/agent/${agentId}/phone-numbers`, { phoneNumbers });
